import script from "./RequestRegulatoryDocumentAction.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestRegulatoryDocumentAction.vue?vue&type=script&setup=true&lang=js"

import "./RequestRegulatoryDocumentAction.vue?vue&type=style&index=0&id=deab6f5c&lang=less"

const __exports__ = script;

export default __exports__